export default "__VITE_ASSET__wckiixzW__"